








































import {
  computed,
  defineComponent,
  ref,
  Ref,
  toRefs
} from '@nuxtjs/composition-api'
import { formFieldProps } from '~/constants/form'
import { useClassifiedForm } from '~/compositions/form'
import { Option } from '~/models/shared/types'
import { mapBackendOptionToOption } from '~/utils/form'
import { range } from '~/utils/array'

import { useI18n } from '~/compositions/i18n'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedMonth: Ref<number | null> = ref(null)
    const selectedYear: Ref<number | null> = ref(null)

    function onValue(v: Ref<{ month: number; year: number } | null>) {
      if (!v.value) {
        return
      }
      selectedMonth.value = v.value.month || null
      selectedYear.value = v.value.year || null
    }

    const { valueChanged, error } = useClassifiedForm(props, { onValue })
    const { t } = useI18n()

    const monthsOptions = computed(() =>
      specs.value.months.map(mapBackendOptionToOption)
    )

    const yearsOptions: Ref<Option[]> = computed(() => [
      { text: t('').toString(), value: null },
      ...range(specs.value.years.min, specs.value.years.max)
        .reverse()
        .map(y => ({ text: y.toString(), value: y }))
    ])

    const monthError = computed(() => error.value && error.value.month)
    const yearError = computed(() => error.value && error.value.year)

    function handleMonthChange(month: number) {
      valueChanged(name.value, { month, year: selectedYear.value })
    }

    function handleYearChange(year: number) {
      valueChanged(name.value, { month: selectedMonth.value, year })
      if (yearError.value) {
        error.value.year = null
      }
    }

    return {
      selectedMonth,
      selectedYear,
      yearsOptions,
      monthsOptions,
      handleMonthChange,
      handleYearChange,
      monthError,
      yearError,
      // TODO do not return those
      valueChanged,
      error
    }
  }
})
